import React from "react";
import { Navigate } from "react-router-dom";
import Layout from "./Layout";

import { getUser } from "@/hooks/useLocalStorage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/login" />;
  }

  const hasAccess =
    allowedRoles.includes(user.role) || allowedRoles.includes("*");

  return hasAccess ? (
    <Layout>{children}</Layout>
  ) : (
    <Navigate to="/home" replace />
  );
};

export default ProtectedRoute;
